<template>
  <el-dialog
    title="异常改签-选择班次"
    :visible.sync="changeShow"
    width="66%"
    :append-to-body="true"
    :close-on-click-modal="false"
    @open="getMerchantList"
  >
    <el-row :gutter="20">
      <el-col :span="20">
        <el-form :model="searchParam" :inline="true" label-width="90px" size="mini">
          <el-form-item label="当前日期：" prop="merchantId">
            <el-date-picker
              v-model="searchParam.startDate"
              type="date"
              placeholder="选择日期"
              format="MM 月 dd 日"
              value-format="yyyy-MM-dd"
              style="width: 14vw"
              @change="handleDate"
            />
          </el-form-item>
          <el-form-item label="供应商：" prop="merchantId">
            <el-select
              v-model="searchParam.merchantId"
              filterable
              placeholder="请选择供应商"
              clearable
              @change="merchantChange"
            >
              <el-option
                v-for="item in merchantList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-form>

        <div class="tipsBox">
          <img style="vertical-align: middle; width: 20px; height: 20px" src="./static/tips.png" />
          <span>选择改签日期后可查看班次，点击班次后的“改签”进入确认行程信息页面！</span>
        </div>
      </el-col>
    </el-row>
    <el-table v-loading="loading" :data="tableData" size="small" border max-height="280">
      <el-table-column label="班次ID" align="center" width="90" prop="id" />
      <el-table-column label="发车时间" align="center" width="180" prop="departureDate">
        <template slot-scope="scope">
          <div v-if="scope.row.adjustTime < 0">
            {{ scope.row.otherDate }} {{ scope.row.otherTime }} -
            <div v-if="scope.row.spanDay === 0">{{ scope.row.departureTime }}</div>
            <div v-else> {{ scope.row.departureDate + ' ' + scope.row.departureTime }}</div>
          </div>
          <div v-else>
            {{ scope.row.departureDate + ' ' + scope.row.departureTime }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="司机信息" align="center" width="150" prop="driverName">
        <template slot-scope="scope">
          {{ scope.row.driverName + ' ' + scope.row.driverPhone }}
        </template>
      </el-table-column>
      <el-table-column label="车辆信息" align="center" width="100" prop="plateNumber" />
      <el-table-column label="标签" align="center" width="120" prop="labelStr" />
      <el-table-column label="供应商" align="center" width="120" prop="merchantName" />
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click.stop="handleChange(scope.row)">改签</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageState.currentPage"
      :page-sizes="[5, 10, 20, 50, 100]"
      :page-size="pageState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageState.total"
    />
    <changeDetail @submit="submit" />
  </el-dialog>
</template>

<script >
import { inject, ref, onMounted, provide } from '@vue/composition-api';
import { getPage, getMerchant } from '@/api/transport/ticketsche';
import { changeOrderInfo, orderChange } from '@/api/express/order';
import { useTableList } from '@/hooks';
import { isEmpty } from 'lodash-es';
import changeDetail from './change-detail.vue';
import { Loading, Message } from 'element-ui';
import dayjs from 'dayjs';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const changeShow = inject('changeShow');
  const info = inject('info');
  const getDetail = inject('getDetail');
  const merchantList = ref([]);
  const changeInfo = ref({});
  const detailShow = ref(false);
  let sectionId = '';
  provide('changeInfo', changeInfo);
  provide('detailShow', detailShow);
  const {
    loading,
    tableData,
    pageState,
    searchParam,
    handleCurrentChange,
    handleSizeChange,
    search
  } = useTableList(getPage, {
    departureIds: [info.value.startStationId],
    destinationIds: [info.value.endStationId],
    merchantIds: [info.value.merchantId],
    startDate: dayjs(new Date()).format('YYYY-MM-DD')
  });
  const getMerchantList = async () => {
    const {
      code,
      data
    } = await getMerchant(info.value.lineId);
    if (code === 0) {
      merchantList.value = data;
    }
  };
  const merchantChange = val => {
    if (!isEmpty(val)) {
      searchParam.value.merchantIds = [val];
    } else {
      searchParam.value.merchantIds = [info.value.merchantId];
    }
    search();
  };
  const handleDate = val => {
    if (!isEmpty(val)) {
      searchParam.value.startDate = val;
    } else {
      searchParam.value.startDate = dayjs(new Date()).format('YYYY-MM-DD');
    }
    search();
  };
  const handleChange = async row => {
    sectionId = row.id;
    const params = {
      orderId: info.value.id,
      sectionId: row.id
    };
    const {
      code,
      data
    } = await changeOrderInfo(params);
    if (code === 0) {
      changeInfo.value = data;
      detailShow.value = true;
    }
  };
  const submit = async remarksBackstage => {
    Loading.service();
    const params = {
      orderId: info.value.id,
      sectionId,
      platform: 2,
      remarksBackstage
    };
    const {
      code
    } = await orderChange(params);
    if (code === 0) {
      Message.success('改签成功！');
      detailShow.value = false;
      changeShow.value = false;
      changeInfo.value = {};
      getDetail(info.value.id);
    }
    Loading.service().close();
  };
  onMounted(() => {
    searchParam.value.startDate = dayjs(new Date()).format('YYYY-MM-DD');
    getMerchantList();
  });
  return {
    changeShow,
    merchantList,
    loading,
    tableData,
    pageState,
    searchParam,
    handleCurrentChange,
    handleSizeChange,
    getMerchantList,
    merchantChange,
    handleDate,
    handleChange,
    submit
  };
};
__sfc_main.components = Object.assign({
  changeDetail
}, __sfc_main.components);
export default __sfc_main;
</script>

<style lang="scss" scoped></style>
